import { render, staticRenderFns } from "./UserListButtons.vue?vue&type=template&id=31375ecb&"
import script from "./UserListButtons.vue?vue&type=script&lang=js&"
export * from "./UserListButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports